import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './PortFolio.css';

// import Sidebar from '../Home/Sidebar';
import { Button } from "react-bootstrap";
import { Link } from 'react-router-dom';
import { axiosOpen } from '../../api/axios';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import Loader from '../../component/Loader/Loader';

const Portfolio = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [isLoading, setIsLoading] = useState(true);

//   const { user } = useContext(AuthContext);
//   console.log(location);
    const [portfolios, setPortfolios] = useState([]);
    async function callAPI(id) {
       navigate(`/portfolio/update/${id}`)
    }
    useEffect(() => {
      const fetchData = async () => {
        const result = await axiosOpen.get('/api/techstack/getAllTechstacks/'+localStorage.getItem('userID'));
        setPortfolios(result.data);
      setIsLoading(false);
      };
  
      fetchData();
    }, [location]);
  
    return (isLoading ? <Loader /> :
    <>
      {  <div className="row">
          <div className="col-12">
            <div className="page-title ">    
              <div className='container'>
                <div className='float-right'>
                <Link
                to="/addportfolio"
                className={({ isActive }) =>
                  `nav-link text-white ${isActive ? "active" : undefined}`
                }
              >
                  {/* <a href='/addportfolio'> */}
                    <Button
                      className="mt-4 submit-btn"
                      variant="primary"
                      type="submit">
                        Add Portfolio
                    </Button>
                  {/* </a> */}
                  </Link>
                </div>
                <table  className="table ">
                  <thead>
                    <tr>
                        <th>Tech Stack</th>
                        <th>Portfolio URL</th>
                        <th>Projects</th>
                        <th>Action</th>             
                    </tr>
                  </thead>
                  <tbody>
                    {portfolios.map((portfolio) => (
                      <tr key={portfolio._id}>        
                        <td data-label="Tech Stack">{portfolio.tech_stack}</td>
                        <td data-label="Portfolio">{portfolio.portfolio && portfolio.portfolio.length > 60 ? portfolio.portfolio.substring(0,60) + '...': portfolio.portfolio}</td>
                        <td data-label="Projects">{portfolio.projects && portfolio.projects.length > 60 ?  portfolio.projects.substring(0,60) + '...': portfolio.projects}</td>
                        {/* <td  data-label="Action"><button className="btn edit-btn" onClick={()=>callAPI(portfolio._id)}>Edit</button></td>         */}
                        <td className="text-center" data-label="Action">
                        <OverlayTrigger
                          key={portfolio._id}
                          placement="bottom"
                          overlay={<Tooltip id={`tooltip-${portfolio._id}`}>Edit Portfolio</Tooltip>}
                        ><span onClick={() => callAPI(portfolio._id)}><i className="btn bi bi-pencil-square"></i></span>
                        </OverlayTrigger>
                      </td>
                      </tr>
                        ))}        
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div> }  
    </>
    );
  };
  
  export default Portfolio;
